export default function BasicButton({
  text="",
  onClick=() => null,
  className = "", // className passthrough for more customizability
} : {
  text?: string,
  onClick?: () => void,
  className?: string,
}) {
  return (
    <button className={`border-2 border-black py-2 px-4 bg-[#BCB7A8] hover:bg-[#a19881] transition duration-100 ${className}`} onClick={onClick}>{text}</button>
  )
}
